<div class="p-3 rounded-3">
  <div class="row">
    <div class="col-12 mb-3 d-flex">
      <div class="col-12 col-sm-9 col-md-9 col-lg-9 align-self-center">
        <div class="titletoptables">
          <div class="leftsideicons">
            <img src="../../../assets/image/report-view-icon.png" alt="report-view" onkeydown="" />
          </div>
          <h3>
            {{ reportName }}
          </h3>
        </div>
      </div>
      <div class="col-12 col-sm-3 col-md-3 col-lg-3 text-end">
        <button (click)="navigateToReports()" class="btn btn-primary"><span class="k-icon k-i-undo"></span>
          Back</button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 mb-3 d-flex">
      <div class="col-12 col-sm-6 col-md-2 col-lg-2 align-self-center">
        <div class="srchgrid texttarget">
          <input class="searchtextbox" matInput (keyup)="filterData($any($event.target).value)" [value]="searchText"
            placeholder="Search" autocomplete="off">
          <div class="closeicon" (keydown.enter)="clearList()" (click)="clearList()"> <span
              aria-hidden="true">&times;</span> </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-10 col-lg-10 text-end"
        *ngIf="reportName == 'Storage Report' || this.reportId == 5">
        <button type="button" (click)="onExcelExport()" class="btn btn-excel">Export Excel
          <img src="../../../assets/image/export-to-excel.png" alt="Logo" class="btnicon" />
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-sm-6 col-md-1 col-lg-1 align-self-center"
      *ngIf="reportName !== 'Storage Report' && this.reportId !== 5">
      <div class="kt-margin-bottom-20-mobile" style="margin-left:10px">
        <form autocomplete="off" [formGroup]="formGroup">
          <mat-form-field class="w-100 custom-blue">
            <mat-select placeholder="Report Duration" formControlName="Report"
              (selectionChange)="selectedOption($event)" [panelClass]="'dropdown-style'"
              [disableOptionCentering]="true">
              <mat-option *ngFor="let items of dropdownValueList" [value]="items">
                {{ items.text }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </form>
      </div>
    </div>
    <div class="col-12 col-sm-8 col-md-8 col-lg-8 align-self-center" *ngIf="this.parentId && this.reportId !== 5">
      <div class="kt-margin-bottom-20-mobile" *ngIf="this.parentId == 1">
        <label>
          <span style="font-weight: 400; font-size: 16px; color: #4a4a4a;">
            Showing result for :{{ this.Date | date : "dd/MM/YYYY" }}</span>
        </label>
      </div>
      <div class="kt-margin-bottom-20-mobile" *ngIf="this.parentId == 2">
        <label>
          <span class="" style="font-weight: 400; font-size: 16px; color: #4a4a4a; ">
            Showing result for the time duration From {{ this.firstDay | date :
            "dd/MM/YYYY" }}
          </span>
          <span style="font-weight: 400; font-size: 16px; color: #4a4a4a;">
            To {{ this.lastDay | date : "dd/MM/YYYY" }}</span>
        </label>
      </div>
      <div class=" kt-margin-bottom-20-mobile " *ngIf="this.parentId == 3">
        <label for="dateInput1">
          <span style="font-weight: 400; font-size: 16px; color: #4a4a4a ;">
            Showing result for the time duration From {{ this.firstDay | date :
            "dd/MM/YYYY" }}
          </span>
          <span style="font-weight: 400; font-size: 16px; color: #4a4a4a;">
            To {{ this.lastDay | date : "dd/MM/YYYY" }}</span>
        </label>
      </div>
      <div class=" kt-margin-bottom-20-mobile" *ngIf="this.parentId == 4">
        <label for="dateInput">
          <span style="font-weight: 400; font-size: 16px; color: #4a4a4a; ">
            {{'Showing result for the time duration From'}}&nbsp;&nbsp;
          </span>
          <span style="font-weight: 400; font-size: 16px; color: #4a4a4a;">
            {{showDate}}
          </span>
        </label>
      </div>
      <div class="kt-margin-bottom-20-mobile" *ngIf="this.parentId == 5">
        <kt-date-picker (valueChange)="UpdateReportData($event)"></kt-date-picker>
      </div>
    </div>
    <div class="col-12 col-sm-2 col-md-2 col-lg-3 text-end"
      *ngIf="reportName !== 'Storage Report' && this.reportId !== 5">
      <button type="button" (click)="onExcelExport()" class="btn btn-excel">Export Excel
        <img src="../../../assets/image/export-to-excel.png" alt="Logo" class="btnicon" />
      </button>
    </div>
  </div>

  <ng-container
    *ngIf="reportName !== 'Storage Report' && reportName !== 'Add-on History Report' && this.reportId == 1 || this.reportId == 2">
    <kendo-grid class="report-grid" [data]="kendoData" [sort]="state.sort" [resizable]="true" [reorderable]="true"
      [columnMenu]="{ filter: true }" [filter]="state.filter" [sortable]="true" [pageSize]="state.take"
      [skip]="state.skip" [group]="state.group" [filterable]="false"
      [pageable]="kendoData?.data?.length && kendoData.data.length > 0 ? pageableWithAll : false" [groupable]="true"
      (dataStateChange)="!!kendoData ? dataStateChange($event) : null" [height]="gridHeight">
      <kendo-grid-column field="Id" title="Id" [width]="100"></kendo-grid-column>
      <kendo-grid-column field="CompanyName" title="Company Name" [width]="180"></kendo-grid-column>
      <kendo-grid-column field="Domain" title="Domain" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="ClientName" title="Admin Name" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="Email" title="Email" [width]="200"></kendo-grid-column>
      <kendo-grid-column field="MobileNumber" title="Mobile Number" [width]="150"></kendo-grid-column>

    </kendo-grid>
  </ng-container>
  <ng-container *ngIf="reportName === 'Storage Report'">
    <kendo-grid class="report-grid" [data]="kendoData" [sort]="state.sort" [resizable]="true" [reorderable]="true"
      [columnMenu]="{ filter: true }" [filter]="state.filter" [sortable]="true" [pageSize]="state.take"
      [skip]="state.skip" [group]="state.group" [filterable]="false"
      [pageable]="kendoData?.data?.length && kendoData.data.length > 0 ? pageableWithAll : false" [groupable]="true"
      (dataStateChange)="!!kendoData ? dataStateChange($event) : null" [height]="gridHeight2">
      <kendo-grid-column field="CompanyName" title="Company Name" [width]="180"></kendo-grid-column>
      <kendo-grid-column field="Domain" title="Domain" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="ClientName" title="Client Name" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="MobileNumber" title="Mobile Number" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="Email" title="Email"></kendo-grid-column>
      <kendo-grid-column field="SubscriptionPlan" title="Subscription Plan"></kendo-grid-column>
      <kendo-grid-column field="RemainingStorage" title="Used Storage(GB)"></kendo-grid-column>
      <kendo-grid-column field="Storage" title="Total Storage Used">
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="dataItem.RemainingStorage !== 'Unlimited'; else unlimitedTemplate">
            <div class="storage-bar-container">
              <div class="storage-bar" [ngStyle]="{ 
                width: dataItem.Storage, 
                backgroundColor: getStorageColor(dataItem.Storage) 
              }">
              </div>
              <span class="storage-label">{{ dataItem.Storage }}</span>
            </div>
          </ng-container>
          <ng-template #unlimitedTemplate>
            <div>Unlimited</div>
          </ng-template>
        </ng-template>
      </kendo-grid-column>




    </kendo-grid>
  </ng-container>
  <ng-container *ngIf="reportName === 'Add-on History Report'">
    <kendo-grid class="report-grid" [data]="kendoData" [sort]="state.sort" [resizable]="true" [reorderable]="true"
      [columnMenu]="{ filter: true }" [filter]="state.filter" [sortable]="{ mode: 'single' }" filterable="menu"
      [pageSize]="state.take" [skip]="state.skip"
      [pageable]="kendoData?.data?.length && kendoData.data.length > 0 ? pageableWithAll : false"
      (dataStateChange)="!!kendoData ? dataStateChange($event) : null" [group]="groups" [groupable]="true"
      [height]="gridHeight">
      <kendo-grid-column field="AddOnName" title="Add-on Name/Type"></kendo-grid-column>
      <kendo-grid-column field="CompanyName" title="Company Name"></kendo-grid-column>
      <kendo-grid-column field="Email" title="Email"></kendo-grid-column>
      <kendo-grid-column field="AddOnDate" title="Purchase Date">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.AddOnDate | date: "dd/MM/YYYY hh:mm a" }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="ExpiryDate" title="Expiry Date">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.ExpiryDate | date: "dd/MM/YYYY" }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="AddOnCount" title="Quantity"></kendo-grid-column>
      <kendo-grid-column field="AddOnAmount" title="Amount (₹)"></kendo-grid-column>
      <kendo-grid-column field="Status" class="" title="Status">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [ngStyle]="{ color: dataItem.Status === 'Active' ? 'green' : 'red'}">
            {{ dataItem.Status }}
          </span>
        </ng-template></kendo-grid-column>
      <kendo-grid-column field="PaymentCollectedBy" title="Payment Collected By"></kendo-grid-column>

    </kendo-grid>
  </ng-container>
  <ng-container *ngIf="this.reportId == 5">
    <kendo-grid class="report-grid" [data]="kendoData" [sort]="state.sort" [resizable]="true" [reorderable]="true"
      [columnMenu]="{ filter: true }" [filter]="state.filter" [sortable]="true" [pageSize]="state.take"
      [skip]="state.skip" [group]="state.group" [filterable]="false"
      [pageable]="kendoData?.data?.length && kendoData.data.length > 0 ? pageableWithAll : false"
      (dblclick)="onRowDoubleClick($event)" [groupable]="true"
      (dataStateChange)="!!kendoData ? dataStateChange($event) : null" [height]="gridHeight2">
      <kendo-grid-column field="Company" title="Company Name">
      </kendo-grid-column>
      <kendo-grid-column [width]="200" title="Action" field="Id">
        <ng-template kendoGridCellTemplate let-dataItem>
          <img src="../../assets/image/view-icon.png" class="ico20" (click)="onViewClicked(dataItem)" />
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>

    <ng-template #ReminderMessageStatusDialog>
      <div class=" mb-2 custom-header">
        <h2 mat-dialog-title>
          Reminder Message Status <span *ngIf="this.companyName"> for {{ this.companyName }}</span>
        </h2>
        <button type="button" class="btn-close" mat-dialog-close data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <mat-dialog-content class="no-scroll-dialog">
        <div class="grid-scroll-container">
          <kendo-grid [height]="350"
            [pageable]="reminderMessageData?.data?.length && reminderMessageData.data.length > 0 ? pageableWithAll : false"
            [sortable]="true" [sort]="childState.sort" [resizable]="true" [reorderable]="true"
            [pageSize]="childState.take" [skip]="childState.skip" [columnMenu]="{ filter: true }"
            [filter]="childState.filter" filterable="menu" [data]="reminderMessageData"
            (dataStateChange)="reminderMessageData ? dataStateChange($event, true) : null" [height]="gridHeight">
            <kendo-grid-column field="PatientName" title="Patient Name" [width]="200">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.PatientName }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="AppointmentDate" title="Appointment Date" [width]="120">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.AppointmentDate }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="AppointmentTime" title="Appointment Time" [width]="120">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.AppointmentTime }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Type" title="Type" [width]="150">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.Type }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Status" [width]="90">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span [ngStyle]="{ color: dataItem.Status === 'Success' ? 'green' : 'red'}">
                  {{ dataItem.Status }}
                </span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="TemplateName" title="Template Name" [width]="230">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.TemplateName }}
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </div>
      </mat-dialog-content>
    </ng-template>

    <ng-template #ReminderMessageStatusExport>
      <div class="modal-header mb-2" style="border-bottom: 1px solid #80808075 !important;">
        <h2 mat-dialog-title>
          Reminder Message Status Export
        </h2>
        <button type="button" class="btn-close" mat-dialog-close data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <mat-dialog-content>
        <div class="mb-2">
          <input type="text" class="form-control" placeholder="Search company..." [formControl]="searchControl">
        </div>

        <div class="form-check mb-2">
          <input type="checkbox" class="form-check-input" id="selectAll" [checked]="isAllSelected()"
            (change)="toggleSelectAll($event)">
          <label class="form-check-label" for="selectAll">Select All</label>
        </div>
        <div class="company-list" style="max-height: 350px; overflow-y: auto;">
          <div *ngFor="let company of filteredCompanies()" class="form-check">
            <input [value]="company.Id" [checked]="selectedCompanyIds.includes(company.Id)"
              (change)="onCompanyToggle(company.Id, $event)" type="checkbox" [id]="'company-' + company.Id"
              class="form-check-input" />
            <label class="form-check-label" [for]="'company-' + company.Id">
              {{ company.Company }}
            </label>
          </div>
        </div>
      </mat-dialog-content>
      <div class="modal-footer mt-3 text-end">
        <button mat-raised-button class="btn btn-secondary cancel-button" style="padding-right: 10px;"
          mat-dialog-close>Cancel</button>
        <button mat-raised-button class="btn btn-primary" (click)="exportSelectedCompanies()">Export</button>
      </div>
    </ng-template>

    <kendo-excelexport [data]="flattenedExportData" fileName="Report.xlsx" #ReminderMessageStatusReport>
      <kendo-excelexport-column field="Company" title="Company Name"></kendo-excelexport-column>
      <kendo-excelexport-column field="PatientName" title="Patient Name"></kendo-excelexport-column>
      <kendo-excelexport-column field="AppointmentDate" title="Appointment Date"></kendo-excelexport-column>
      <kendo-excelexport-column field="AppointmentTime" title="Appointment Time"></kendo-excelexport-column>
      <kendo-excelexport-column field="Type" title="Type"></kendo-excelexport-column>
      <kendo-excelexport-column field="Status" title="Status"></kendo-excelexport-column>
      <kendo-excelexport-column field="TemplateName" title="TemplateName"></kendo-excelexport-column>
    </kendo-excelexport>
  </ng-container>

  <kendo-excelexport [data]="kendoData.data" fileName="Report.xlsx" #excelexport>
    <!-- Export columns for Storage Report -->
    <ng-container *ngIf="reportName === 'Storage Report'">
      <kendo-excelexport-column field="CompanyName" title="Company Name"></kendo-excelexport-column>
      <kendo-excelexport-column field="Domain" title="Domain"></kendo-excelexport-column>
      <kendo-excelexport-column field="MobileNumber" title="Mobile Number"></kendo-excelexport-column>
      <kendo-excelexport-column field="Email" title="Email"></kendo-excelexport-column>
      <kendo-excelexport-column field="SubscriptionPlan" title="Subscription Plan"></kendo-excelexport-column>
      <kendo-grid-column field="RemainingStorage" title="Used Storage(GB)"></kendo-grid-column>
      <kendo-excelexport-column field="Storage" title="Storage"></kendo-excelexport-column>
    </ng-container>

    <!-- Export columns for other reports -->
    <ng-container *ngIf="reportName !== 'Storage Report' && reportName !== 'Add-on History Report'">
      <kendo-excelexport-column field="Id" title="Company Id"></kendo-excelexport-column>
      <kendo-excelexport-column field="CompanyName" title="Company Name"></kendo-excelexport-column>
      <kendo-excelexport-column field="Domain" title="Domain"></kendo-excelexport-column>
      <kendo-excelexport-column field="AdminName" title="Admin Name"></kendo-excelexport-column>
      <kendo-excelexport-column field="Email" title="Email"></kendo-excelexport-column>
      <kendo-excelexport-column field="MobileNumber" title="Mobile No"></kendo-excelexport-column>
    </ng-container>

    <!-- Export Add-on History Report -->
    <ng-container *ngIf="reportName === 'Add-on History Report'">
      <kendo-excelexport-column field="AddOnName" title="Add-on Name/Type"></kendo-excelexport-column>
      <kendo-excelexport-column field="CompanyName" title="Company Name"></kendo-excelexport-column>
      <kendo-excelexport-column field="Email" title="Email"></kendo-excelexport-column>
      <kendo-excelexport-column field="AddOnDate" title="Purchase Date">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.AddOnDate | date: "dd/MM/YYYY hh:mm a" }}
        </ng-template>
      </kendo-excelexport-column>
      <kendo-excelexport-column field="ExpiryDate" title="Expiry Date">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.ExpiryDate | date: "dd/MM/YYYY" }}
        </ng-template>
      </kendo-excelexport-column>
      <kendo-excelexport-column field="AddOnCount" title="Quantity"></kendo-excelexport-column>
      <kendo-excelexport-column field="AddOnAmount" title="Amount (₹)"></kendo-excelexport-column>
      <kendo-excelexport-column field="Status" title="Status"></kendo-excelexport-column>
      <kendo-excelexport-column field="PaymentCollectedBy" title="Payment Collected By"></kendo-excelexport-column>
    </ng-container>
  </kendo-excelexport>